"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBundleInputStore = void 0;
var zustand_1 = require("zustand");
var initialState = {
    presetSizeStepHeader: undefined,
    presetSizes: undefined,
    presetPreferredPatternGender: undefined,
    presetDiaperSizeRationale: undefined,
    presetTrainingPantSizeRational: undefined,
    presetPatternStepHeader: undefined,
};
var bundleStoreInitializer = function (set) { return (__assign(__assign({}, initialState), { changePresetSizeStepHeader: function (header) {
        set({ presetSizeStepHeader: header });
    }, changePresetSizes: function (sizes) {
        set({ presetSizes: sizes });
    }, changePresetPreferredPatternGender: function (gender) {
        set({ presetPreferredPatternGender: gender });
    }, changePresetDiaperSizeRationale: function (message) {
        set({ presetDiaperSizeRationale: message });
    }, changePresetTrainingPantSizeRational: function (message) {
        set({ presetTrainingPantSizeRational: message });
    }, changePresetPatternStepHeader: function (header) {
        set({ presetPatternStepHeader: header });
    }, reset: function () {
        set(initialState);
    } })); };
// We have a bunch of code commented out here that can be used to persist the bundle input to localStorage if we ever need to.
// This is useful when the logic that puts data into our bundle store does not exist on the same page as our bundler, in which
// case we need to serialize and save the input to localStorage and then read it form localStorage after the user is redirected
// to the bundler page.
// TODO: simply store the bundle state in the url (and set up partialize to only disregard
// functions so that the bundle's persistence layer is not dependent on the particularities of the diaper quiz)
// type PersistListener<S> = (state: S) => void
// type StorePersist<S, Ps> = {
//   persist: {
//     setOptions: (options: Partial<PersistOptions<S, Ps>>) => void
//     clearStorage: () => void
//     rehydrate: () => Promise<void> | void
//     hasHydrated: () => boolean
//     onHydrate: (fn: PersistListener<S>) => () => void
//     onFinishHydration: (fn: PersistListener<S>) => () => void
//     getOptions: () => Partial<PersistOptions<S, Ps>>
//   }
// }
// type Write<T, U> = Omit<T, keyof U> & U
// let bundleInputStore: { useBundleInputStore: UseBoundStore<Write<StoreApi<BundleInputFullState>, StorePersist<BundleInputFullState, BundleInputFullState>>> }
var bundleInputStore;
function getBundleInputStore() {
    if (bundleInputStore)
        return bundleInputStore;
    bundleInputStore = {
        useBundleInputStore: (0, zustand_1.create)(bundleStoreInitializer),
    };
    return bundleInputStore;
}
exports.getBundleInputStore = getBundleInputStore;
